import { gql, useMutation } from '@apollo/client'
import { map, pick } from 'ramda'

import { placesClient } from '../../../../utils/apollo/api'
import { useCloseModal } from '../../../../components/modals/ModalsContext'
import { useLevelsSettingsForm } from '../_form/LevelSettingsFormHandler'

const MUTATION = gql`
  mutation UpsertLevels($inputs: [LevelInput]) {
    upsertLevels(inputs: $inputs) {
      id
    }
  }
`

const cleanRequest = map(pick(['id', 'name', 'enabled']))

export const useSaveLevels = onSuccess => {
  const closeModal = useCloseModal()
  const { levels } = useLevelsSettingsForm()
  const [request, state] = useMutation(MUTATION, { refetchQueries: ['Levels'], client: placesClient })

  const handleRequest = () => {
    const inputs = cleanRequest(levels)

    return request({ variables: { inputs } }).then(resp => {
      if (!resp.errors) {
        placesClient.resetStore()
        closeModal()
        if (!!onSuccess) onSuccess(resp)
      }
    })
  }

  return [handleRequest, state]
}
